(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-ppc"]) return;
  try {
    
  (function () {
    // Inject CSS that owns header top and body padding via --bar-height variable.
    // !important beats Attrac's inline body.style.paddingTop.
    // Body padding builds on the theme's existing --header-height-mobile/desktop vars.
    // Guarded by id so it is safe to include in both header variants.
    if (!document.getElementById('header-offset-style')) {
      const s = document.createElement('style')
      s.id = 'header-offset-style'
      s.textContent = [
        '.aph_bar_bar { position: absolute !important; top: 0 !important; z-index: 40 !important; }',
        '.aph_bar_plchold { display: none !important; }',
        '.affiliate-bar { position: absolute !important; top: 0 !important; z-index: 50 !important; width: 100%; }',
        'body.has-affiliate-banner .aph_bar_bar { display: none !important; }',
        '.header { top: var(--bar-height, 0px) !important; }',
        'body { padding-top: calc(var(--header-height-mobile) + var(--bar-height, 0px)) !important; }',
        '@media screen and (min-width: 976px) {',
        '  body { padding-top: calc(var(--header-height-desktop) + var(--bar-height, 0px)) !important; }',
        '}'
      ].join('')
      document.head.appendChild(s)
    }

    var barRO = null
    var barROTarget = null

    function setBarHeight() {
      var affiliateBar = document.querySelector('.affiliate-bar:not([hidden])')
      var bar = affiliateBar || document.querySelector('.aph_bar_bar')
      var h = bar ? bar.offsetHeight : 0
      if (bar && !affiliateBar) bar.style.zIndex = '40'
      var inlinePos = bar ? bar.style.position : ''
      var pinned = inlinePos === 'fixed' || inlinePos === 'sticky'
      document.body.style.setProperty('--bar-height', (pinned ? h : Math.max(0, h - window.scrollY)) + 'px')

      if ('ResizeObserver' in window && bar !== barROTarget) {
        if (barRO) barRO.disconnect()
        barROTarget = bar
        if (bar) {
          barRO = new ResizeObserver(setBarHeight)
          barRO.observe(bar)
        }
      }
    }

    setBarHeight()
    window.addEventListener('resize', setBarHeight)
    window.addEventListener('load', setBarHeight)
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setBarHeight)

    var rafPending = false
    window.addEventListener('scroll', function () {
      if (rafPending) return
      rafPending = true
      requestAnimationFrame(function () {
        rafPending = false
        setBarHeight()
      })
    }, { passive: true })

    if (typeof MutationObserver === 'function' && document.body) {
      var mo = new MutationObserver(function () {
        var aphBar = document.querySelector('.aph_bar_bar')
        if (aphBar) {
          mo.disconnect()
          clearTimeout(moTimeout)
          requestAnimationFrame(function () {
            var intended = aphBar.style.position
            if (intended === 'fixed' || intended === 'sticky') {
              aphBar.style.setProperty('position', intended, 'important')
            }
            setBarHeight()
          })
        }
      })
      var moTimeout = setTimeout(function () { mo.disconnect() }, 10000)
      mo.observe(document.body, { childList: true, subtree: true })

      var affiliateBarEl = document.querySelector('.affiliate-bar')
      if (affiliateBarEl) {
        var affiliateMO = new MutationObserver(function () {
          requestAnimationFrame(setBarHeight)
          affiliateMO.disconnect()
        })
        affiliateMO.observe(affiliateBarEl, { attributes: true, attributeFilter: ['hidden'] })
        setTimeout(function () { affiliateMO.disconnect() }, 10000)
      }
    }
  })()

  const modal = document.getElementById('searchModal');
  const searchModalBtn = document.getElementById('triggerSearchModal');
  const searchModalForm = document.getElementById('searchModalForm');
  const mobileMenuForm = document.getElementById('mobileMenuForm');

  // When the user clicks on the button, open the modal
  searchModalBtn.onclick = function () {
    modal.style.display = 'block';
    modal.querySelector('#search').focus()
  };
  searchModalForm.addEventListener('keyup', handleKeyUp)
  mobileMenuForm.addEventListener('keyup', handleKeyUp)

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = 'none';
    }
  };

  function handleKeyUp(evt) {
    const currentHostname = window.location.hostname;
    const currentProtocol = window.location.protocol; // e.g., "http:" or "https:"
    const desiredPath = `/search?q=${evt.target.value}`;
    const newURL = `${currentProtocol}//${currentHostname}${desiredPath}`;

    if (event.key === 'Enter') {
      window.location.assign(newURL);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  (function () {
    // Inject CSS that owns header top and body padding via --bar-height variable.
    // !important beats Attrac's inline body.style.paddingTop.
    // Body padding builds on the theme's existing --header-height-mobile/desktop vars.
    if (!document.getElementById('header-offset-style')) {
      const s = document.createElement('style')
      s.id = 'header-offset-style'
      s.textContent = [
        '.aph_bar_bar { position: absolute !important; top: 0 !important; z-index: 40 !important; }',
        '.aph_bar_plchold { display: none !important; }',
        '.affiliate-bar { position: absolute !important; top: 0 !important; z-index: 50 !important; width: 100%; }',
        'body.has-affiliate-banner .aph_bar_bar { display: none !important; }',
        '.header { top: var(--bar-height, 0px) !important; }',
        'body { padding-top: calc(var(--header-height-mobile) + var(--bar-height, 0px)) !important; }',
        '@media screen and (min-width: 976px) {',
        '  body { padding-top: calc(var(--header-height-desktop) + var(--bar-height, 0px)) !important; }',
        '}'
      ].join('')
      document.head.appendChild(s)
    }

    var barRO = null
    var barROTarget = null

    function setBarHeight() {
      var affiliateBar = document.querySelector('.affiliate-bar:not([hidden])')
      var bar = affiliateBar || document.querySelector('.aph_bar_bar')
      var h = bar ? bar.offsetHeight : 0
      if (bar && !affiliateBar) bar.style.zIndex = '40'
      // Read the INLINE style (not computed) to detect Attrac's sticky intent.
      // Our stylesheet position:absolute !important overrides the computed value,
      // so getComputedStyle always returns 'absolute'. The inline style reflects
      // what Attrac set — preserved via inline !important in the MO callback.
      var inlinePos = bar ? bar.style.position : ''
      var pinned = inlinePos === 'fixed' || inlinePos === 'sticky'
      document.body.style.setProperty('--bar-height', (pinned ? h : Math.max(0, h - window.scrollY)) + 'px')

      // Bind a ResizeObserver to the active bar so any future height change
      // (late content, fonts, images) self-corrects without requiring a scroll.
      // Only reconnect when the observed target changes to avoid churn.
      if ('ResizeObserver' in window && bar !== barROTarget) {
        if (barRO) barRO.disconnect()
        barROTarget = bar
        if (bar) {
          barRO = new ResizeObserver(setBarHeight)
          barRO.observe(bar)
        }
      }
    }

    setBarHeight()
    window.addEventListener('resize', setBarHeight)
    // Belt-and-suspenders: re-measure after all resources and fonts have loaded
    // so image-driven or font-driven height shifts are caught without a scroll.
    window.addEventListener('load', setBarHeight)
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setBarHeight)

    var rafPending = false
    window.addEventListener('scroll', function () {
      if (rafPending) return
      rafPending = true
      requestAnimationFrame(function () {
        rafPending = false
        setBarHeight()
      })
    }, { passive: true })

    if (typeof MutationObserver === 'function' && document.body) {
      // Watch for the Attrac bar being injected by the third-party app.
      var mo = new MutationObserver(function () {
        var aphBar = document.querySelector('.aph_bar_bar')
        if (aphBar) {
          mo.disconnect()
          clearTimeout(moTimeout)
          requestAnimationFrame(function () {
            // Our stylesheet position:absolute !important wins the cascade over
            // Attrac's inline position:fixed (sticky mode). Re-apply Attrac's
            // intended value as an inline !important so sticky is honoured.
            var intended = aphBar.style.position
            if (intended === 'fixed' || intended === 'sticky') {
              aphBar.style.setProperty('position', intended, 'important')
            }
            setBarHeight()
          })
        }
      })
      var moTimeout = setTimeout(function () { mo.disconnect() }, 10000)
      mo.observe(document.body, { childList: true, subtree: true })

      // Also watch the server-rendered affiliate bar's hidden attribute —
      // AffiliateBanner.js removes it after DOMContentLoaded, which the
      // childList observer above cannot detect.
      var affiliateBarEl = document.querySelector('.affiliate-bar')
      if (affiliateBarEl) {
        var affiliateMO = new MutationObserver(function () {
          requestAnimationFrame(setBarHeight)
          affiliateMO.disconnect()
        })
        affiliateMO.observe(affiliateBarEl, { attributes: true, attributeFilter: ['hidden'] })
        setTimeout(function () { affiliateMO.disconnect() }, 10000)
      }
    }
  })()

  const modal = document.getElementById('searchModal');
  const searchModalBtn = document.getElementById('triggerSearchModal');

  if (searchModalBtn) {
    searchModalBtn.onclick = function () {
      modal.style.display = 'block';
      modal.querySelector('#search').focus();
    };
  }

  // Close modal when clicking outside the content area
  if (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
